export default class MessageTemplate {}
